import { DrawerNavigationProp } from '@react-navigation/drawer';
import { useState } from 'react';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { mvs } from 'react-native-size-matters';

import { useAppSelector } from '../app/hooks';
import { CustomIcon } from '../components/CustomIcon';
import CustomText from '../components/CustomText';
import { isTablet } from '../constants';
import { LeftDrawerNavigatorParams } from './LeftDrawerNavigator';
import { selectMenuColor } from '../features/appconfig/store/selectors';
import i18n from '../localization/i18n';
import AboutModalScreen from '../screens/AboutModalScreen';

interface DrawerFooterProps {
  aboutVisibility: boolean;
  settingsActive: boolean;
  navigation?: DrawerNavigationProp<LeftDrawerNavigatorParams>;
}

export function DrawerFooter({
  aboutVisibility,
  settingsActive,
  navigation,
}: DrawerFooterProps) {
  const [aboutModalVisible, setAboutModalVisible] = useState(false);
  const menuColor = useAppSelector(selectMenuColor);

  const handleOpenSettings = () => {
    navigation?.closeDrawer();
    navigation?.navigate('Settings');
  };

  // no footer if nothing to show
  if (!settingsActive && !aboutVisibility) {
    return null;
  }

  const settingsIcon = settingsActive && (
    <CustomIcon
      name="gear"
      size={mvs(20)}
      color={aboutVisibility ? '#9C9C9C' : menuColor}
      onPress={handleOpenSettings}
      accessibilityLabel={i18n.t('settings.title')}
    />
  );

  return (
    <>
      {aboutVisibility ? (
        <View
          style={[
            styles.aboutStrip,
            settingsActive ? styles.aboutStripSpaceBetween : styles.aboutStripCenter,
          ]}
        >
          <TouchableOpacity
            style={styles.footerAbout}
            onPress={() => setAboutModalVisible(true)}
          >
            <Image
              source={require('../assets/images/radioking-logo-small.png')}
              style={styles.radiokingLogoSmall}
            />
            <CustomText
              style={[styles.footerText, settingsActive && styles.footerTextWithSettings]}
              weight="Regular"
            >
              {i18n.t('leftDrawer.about')}
            </CustomText>
          </TouchableOpacity>
          {settingsIcon}
        </View>
      ) : (
        settingsActive && <View style={styles.settingsRow}>{settingsIcon}</View>
      )}
      <AboutModalScreen
        onCancel={() => setAboutModalVisible(false)}
        visible={aboutModalVisible}
      />
    </>
  );
}

const styles = StyleSheet.create({
  settingsRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: mvs(16),
    paddingVertical: mvs(12),
  },
  aboutStrip: {
    backgroundColor: '#F9F9F9',
    height: isTablet ? mvs(50) : mvs(60),
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: mvs(16),
  },
  aboutStripCenter: {
    justifyContent: 'center',
  },
  aboutStripSpaceBetween: {
    justifyContent: 'space-between',
  },
  footerAbout: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  radiokingLogoSmall: {
    aspectRatio: 81 / 98,
    width: 23,
  },
  footerText: {
    color: '#9C9C9C',
    fontSize: isTablet ? mvs(15) : mvs(16),
    marginLeft: mvs(8),
  },
  footerTextWithSettings: {
    fontSize: mvs(14),
  },
});
